
import { Component, ComputedRef, defineComponent, h, PropType } from 'vue';
import { ComponentIdentifier, useBusinessComponent } from '@/shared/layout/business-component.composable';

export default defineComponent({
    name: 'BusinessComponent',
    props: {
        name: {
            required: true,
            type: String as PropType<ComponentIdentifier>,
        },
    },
    setup(props, { slots }) {
        const component: ComputedRef<Component | undefined> = useBusinessComponent(props.name);
        return () => component.value ? h(component.value) : slots.default;
    },
});
